import palette from 'theme/palette';

export default {
  root: {
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: palette.primary[500],
    },
  },
};
